import React from 'react';

const TopBar = ({
  topbar
}) => /*#__PURE__*/React.createElement("div", {
  className: "topbar"
}, /*#__PURE__*/React.createElement("div", {
  className: "topbar__inner"
}, /*#__PURE__*/React.createElement("a", {
  href: topbar.link,
  target: "_blank",
  rel: "noopener noreferrer"
}, topbar.linkText)));

TopBar.displayName = 'TopBar';
export default TopBar;